import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    standalone: true,
    name: 'bypassSecurityTrustHtml',
})
export class BypassSecurityTrustHtmlPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(input: any): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(input);
    }

}
